import React, { Fragment } from 'react';
import PrivacyPolicyComponent from '../components/privacy_policy/privacy_policy_component';
import PageHelmet from '../components/common/PageHelmet';

export default function PrivacyPolicyScreen() {
    return (
        <Fragment>
            <PageHelmet 
                title="Privacy Policy - Rubaai Digital Payment Solutions"
                description="Read Rubaai's Privacy Policy to understand how we collect, use, and protect your personal information. Learn about our commitment to data security and privacy protection."
                keywords="privacy policy, data protection, personal information, security, Rubaai privacy, data collection, privacy rights"
            />
            <PrivacyPolicyComponent />
        </Fragment>
    );
}